import type { VideoProps } from "@emkit/builder-widgets";
import { useEditor } from "../../store.js";
import { CheckboxField, NumberField, SelectField, TextField } from "./fields.js";
import { MediaField } from "./MediaField.js";
import type { WidgetInspectorProps } from "./registry.js";

const SOURCE = ["youtube", "vimeo", "url"] as const;
const ASPECTS = ["16/9", "4/3", "1/1", "21/9"] as const;

export function VideoInspector({ widget }: WidgetInspectorProps) {
  const update = useEditor((s) => s.updateWidgetProps);
  const p = widget.props as VideoProps;

  return (
    <>
      <SelectField
        label="Source"
        value={p.source}
        options={SOURCE}
        onChange={(v) => update(widget.id, { source: v })}
      />
      {p.source === "url" ? (
        <MediaField
          label="Video URL (mp4/webm)"
          value={p.src}
          accept="video/*"
          onChange={(v) => update(widget.id, { src: v })}
        />
      ) : (
        <TextField
          label={p.source === "youtube" ? "YouTube URL" : "Vimeo URL"}
          value={p.src}
          onChange={(v) => update(widget.id, { src: v })}
        />
      )}
      <SelectField
        label="Aspect ratio"
        value={p.aspectRatio}
        options={ASPECTS}
        onChange={(v) => update(widget.id, { aspectRatio: v })}
      />
      <CheckboxField
        label="Autoplay"
        value={p.autoplay}
        onChange={(v) => update(widget.id, { autoplay: v })}
      />
      <CheckboxField
        label="Muted (required for autoplay in most browsers)"
        value={p.muted}
        onChange={(v) => update(widget.id, { muted: v })}
      />
      <CheckboxField
        label="Loop"
        value={p.loop}
        onChange={(v) => update(widget.id, { loop: v })}
      />
      <CheckboxField
        label="Show controls"
        value={p.controls}
        onChange={(v) => update(widget.id, { controls: v })}
      />
      <NumberField
        label="Corner radius (px)"
        value={p.radius ?? 0}
        min={0}
        max={64}
        onChange={(v) => update(widget.id, { radius: v })}
      />
    </>
  );
}
